export default __webpack_public_path__ + "static/media/appstore-badge.c1338e6f.png";